export enum AnnotationsRequestTypes {
  BulkDeleteAnnotationsFailure = 'annotations/BULK_DELETE_ANNOTATIONS_FAILURE',
  BulkDeleteAnnotationsRequest = 'annotations/BULK_DELETE_ANNOTATIONS_REQUEST',
  BulkDeleteAnnotationsSuccess = 'annotations/BULK_DELETE_ANNOTATIONS_SUCCESS',
  CreateAnnotationFailure = 'annotations/CREATE_ANNOTATION_FAILURE',
  CreateAnnotationRequest = 'annotations/CREATE_ANNOTATION_REQUEST',
  CreateAnnotationSuccess = 'annotations/CREATE_ANNOTATION_SUCCESS',
  DeleteAnnotationAndAssociationFailure = 'annotations/DELETE_ANNOTATION_AND_ASSOCIATION_FAILURE',
  DeleteAnnotationAndAssociationRequest = 'annotations/DELETE_ANNOTATION_AND_ASSOCIATION_REQUEST',
  DeleteAnnotationAndAssociationSuccess = 'annotations/DELETE_ANNOTATION_AND_ASSOCIATION_SUCCESS',
  GetAnnotationsForDxObjectRequest = 'annotations/GET_ANNOTATIONS_REQUEST',
  GetAnnotationsForDxObjectSuccess = 'annotations/GET_ANNOTATIONS_SUCCESS',
  GetAnnotationsForDxObjectFailure = 'annotations/GET_ANNOTATIONS_FAILURE',
  GetAnnotationsAccessFailure = 'annotations/GET_ANNOTATIONS_ACCESS_FAILURE',
  GetAnnotationsAccessRequest = 'annotations/GET_ANNOTATIONS_ACCESS_REQUEST',
  GetAnnotationsAccessSuccess = 'annotations/GET_ANNOTATIONS_ACCESS_SUCCESS',
  GetGlobalAnnotationsRequest = 'annotations/GET_GLOBAL_ANNOTATIONS_REQUEST',
  GetGlobalAnnotationsSuccess = 'annotations/GET_GLOBAL_ANNOTATIONS_SUCCESS',
  GetGlobalAnnotationsFailure = 'annotations/GET_GLOBAL_ANNOTATIONS_FAILURE',
  GetAnnotationsListViewRequest = 'annotations/GET_ANNOTATIONS_LIST_VIEW_REQUEST',
  GetAnnotationsListViewSuccess = 'annotations/GET_ANNOTATIONS_LIST_VIEW_SUCCESS',
  GetAnnotationsListViewFailure = 'annotations/GET_ANNOTATIONS_LIST_VIEW_FAILURE',
  SetAnnotationSettingsRequest = 'annotations/SET_ANNOTATION_SETTINGS_REQUEST',
  SetAnnotationSettingsSuccess = 'annotations/SET_ANNOTATION_SETTINGS_SUCCESS',
  SetAnnotationSettingsFailure = 'annotations/SET_ANNOTATION_SETTINGS_FAILURE',
  UpdateAnnotationFailure = 'annotations/UPDATE_ANNOTATION_FAILURE',
  UpdateAnnotationRequest = 'annotations/UPDATE_ANNOTATION_REQUEST',
  UpdateAnnotationSuccess = 'annotations/UPDATE_ANNOTATION_SUCCESS',
}
